import React, {useCallback} from 'react';
import {GatewayGetSchema} from '../../../../../api/DBSchema/Gateway';
import {SMCCheckbox} from '../../../../../components/Simple/SMCCheckbox';
import {useTranslation} from 'react-i18next';
import PlanEditorInnerContainer from '../../../../../components/Editor/PlanEditorInnerContainer';
import Separator from '../../../../../components/Simple/Sepperator';

import antiVirusIcon from '../../../../../assets/images/anti_virus_64.png';
import {SMCRadio, SMCRadioGroup} from '../../../../../components/Simple/SMCRadio';
import SMCLabel from '../../../../../components/Simple/SMCLabel';
import EmptyRow from '../../../../../components/Simple/EmptyRow';
import EditorLayout from '../../../../../components/Layouts/EditorLayout';
import RowLayout from '../../../../../components/Layouts/RowLayout';
import {SMCToggleSwitch} from "../../../../../components/Simple/SMCToggleSwitch";

const pageSchema = GatewayGetSchema.pages.antiVirus;
const pageId = pageSchema.pageId;

function BaseAntiVirus({
    pageData,
    setObjectData,
    pageDisabled,
    setEditorPageId
}) {
    const { t } = useTranslation();

    const manageInSmp = pageData[pageSchema.manageInSmp];
    const mode        = pageData[pageSchema.mode];
    
    const detect      = pageData[pageSchema.detect];

    const setPageValue = useCallback((param, newValue) => {
        setObjectData([pageId, param], newValue);
    }, [setObjectData]);


    return (
        <EditorLayout>
            <SMCToggleSwitch
                disabled={pageDisabled}
                checked={manageInSmp}
                onChange={checked => setPageValue(pageSchema.manageInSmp, checked)}
                label={t('SMP.PLAN.MANAGE_IN_SMP')}
            />
            <Separator isMainSeparator/>
            <PlanEditorInnerContainer title={t('SMP.PLANS.INNER_MENU.ANTI_VIRUS')} managedInSmp={manageInSmp}>
                <RowLayout>
                    <img alt="" src={antiVirusIcon} />
                    <SMCRadioGroup value={mode ? 'ON' : 'OFF'} onChange={e => setPageValue(pageSchema.mode, e.target.value === 'ON')} disabled={pageDisabled || !manageInSmp}>
                        <SMCRadio value="ON" label={t('SMP.ON')} />
                        <SMCRadio value="OFF" label={t('SMP.OFF')} />
                    </SMCRadioGroup>
                </RowLayout>

                <SMCLabel bold>{t('SMP.PLAN.SEC_SOFT_BLADES.POLICY')}:</SMCLabel>
                <SMCLabel>{t('SMP.PLAN.TP_POLICY_SETTINGS_CONF')}<span className="Link" onClick={() => setEditorPageId(GatewayGetSchema.pages.threatPrevention.pageId)}> {t('SMP.PLAN.THREAT_PREV_POLICY')}</span></SMCLabel>
                <SMCLabel>{t('SMP.PLAN.UNIFIED_TP_POLICY_SETTINGS_CONF')}<span className="Link" onClick={() => setEditorPageId(GatewayGetSchema.pages.unifiedThreatPrevention.pageId)}> {t('SMP.PLAN.UNIFIED_THREAT_PREV_POLICY')}</span></SMCLabel>

                <EmptyRow />

                <SMCCheckbox
                    disabled={pageDisabled || !manageInSmp}
                    checked={detect}
                    onChange={e => setPageValue(pageSchema.detect, e.target.checked)}
                    label={t('SMP.PLAN.DETECT_ONLY_MODE')}
                />

                <EmptyRow />

                <SMCLabel><b>{t('SMP.DESCRIPTION')}: </b>{t('SMP.PLAN.AV.LINE3')}</SMCLabel>
            </PlanEditorInnerContainer>
        </EditorLayout>
    );
}

export default BaseAntiVirus;